import { render, staticRenderFns } from "./TableViewTask.vue?vue&type=template&id=c4344468&"
import script from "./TableViewTask.vue?vue&type=script&lang=ts&"
export * from "./TableViewTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports